import React, { useEffect, useState } from 'react'
import { Switch } from 'antd'
import { FormLabel } from './FormLabel'

const FormSwitch = ({ data, formHook }) => {
  //const { control } = formHook

  const {
    register,
    setValue,
    getValues,
    unregister,
    formState: { errors },
  } = formHook

  const errorState = errors[data.id]
  const errorMessage = errorState && errorState.message ? errorState.message : data.errorMsg

  const currentValue = getValues(data.id) ? getValues(data.id) : data.value

  const [state, setState] = useState<boolean>(currentValue)

  useEffect(() => {
    register(data.id, data.validation)

    return () => {
      unregister(data.id)
    }
  }, [register, unregister, data.id, data.validation])

  useEffect(() => {
    if (data.value) {
      setValue(data.id, data.value)
    } else {
      setValue(data.id, false)
    }
  }, [data.value, data.id, data.validation, register, setValue])

  const onChange = (checked: boolean) => {
    setValue(data.id, checked)
    setState(checked)
  }

  return (
    <div className="col-12 w-100 py-2">
      <FormLabel label={data.label}>
        {data.postfix ? (
          <p>
            {data.label} <span className="opacity-75 p-small">{data.postfix}</span>
          </p>
        ) : null}
      </FormLabel>

      <Switch checked={state} onChange={onChange} />

      {errorState ? <div className="p-small text-danger">{errorMessage}</div> : null}
    </div>
  )
}
export default FormSwitch
